// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Info = function Info(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.875a8.125 8.125 0 1 1 0 16.25 8.125 8.125 0 0 1 0-16.25M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m-1.562-6.875a.935.935 0 0 0-.938.938c0 .519.418.937.938.937h3.124c.52 0 .938-.418.938-.937a.935.935 0 0 0-.937-.938h-.313V9.688a.935.935 0 0 0-.937-.938H8.437a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h.937v2.5zM10 7.5A1.25 1.25 0 1 0 10 5a1.25 1.25 0 0 0 0 2.5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
